<div *ngIf="item$ | async as item" class="selectable-item">
  <div class="line-seperator"></div>
  <form [formGroup]="guestForm" >
    <div class="select-container">
      <p-dropdown placeholder="Select the next node" optionLabel="name" formControlName="defaultItem" id="itemToSelect" class="selectable-item-select"
                  (onChange)="handleSelection()"
                  [required]=true
                  [options]="item.options"
                  [(ngModel)]="selectedOption"
                  [showClear]="false"></p-dropdown>
    </div>
    <div class="line-seperator"></div>
  </form>
</div>



